"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _TopicVoteCount = require("@insided/destination/uikit/TopicVoteCount");

var _classnames = _interopRequireDefault(require("classnames"));

var TopicVoteButtonView = function TopicVoteButtonView(_ref) {
  var count = _ref.count,
      hasVoted = _ref.hasVoted,
      onClick = _ref.onClick;
  return (0, _preact.h)("div", null, (0, _preact.h)("span", {
    className: "topic__votes-count is-hidden-S"
  }, (0, _preact.h)(_TopicVoteCount.TopicVoteButton, {
    size: "small",
    hasVoted: hasVoted,
    onClick: onClick
  }, (0, _preact.h)(_TopicVoteCount.VoteTriangleIcon, {
    size: "small"
  })), (0, _preact.h)(_TopicVoteCount.VoteCountInner, {
    count: count
  })), (0, _preact.h)(_TopicVoteCount.TopicVoteButton, {
    className: (0, _classnames.default)({
      add_spacing: true
    }),
    hasVoted: hasVoted,
    onClick: onClick
  }, (0, _preact.h)(_TopicVoteCount.VoteCountInner, {
    count: count
  }), (0, _preact.h)(_TopicVoteCount.VoteTriangleIcon, null)));
};

var _default = TopicVoteButtonView;
exports.default = _default;